import i18n from 'i18n'
import { AppTimezoneLabel } from 'app/@components/UserTimestamp'
import * as React from "react"
import { useRef } from "react"
import { IconSeekers, ImgS } from "ui-seeker/core"
import OutsideAlerter from "app/components/modals/useOutsider"
import { isEmpty } from 'ui-seeker/utils'
import { IMAGE } from '../../../../@common/constants'
import { useContextSelector } from 'use-context-selector'
import { AppLocationDataContext } from '../../../../providers'
import { AppTooltip } from 'app/@components'
import { IconButtonSeeker } from "ui-seeker/core"

const getOccupationClass = (occupation) => {
    if (!occupation) return '--0'
    if (occupation <= 25) return '--25'
    if (occupation <= 50) return '--50'
    if (occupation <= 75) return '--75'
    return '--100'
}

export default function AppDetailsAction({ date }) {
    const [isOpen, setIsOpen] = React.useState(false)
    const dateLocationData = useContextSelector(AppLocationDataContext, ({ state }) => state)
    const { location_category, occupancy, type_accommodation, site_name, nights, location_name, occupation_dates, latestSearchDate } = dateLocationData
    const detailsRef = useRef(null)

    if(isEmpty(dateLocationData) || !occupation_dates[date]?.occupation) return null


    const renderStars = () => {
        if (!location_category) return null;
        return Array.from({ length: location_category }, (_, index) => (
            <IconSeekers
                key={index}
                style={{ color: '#FFC107', fontSize: '10px' }}
                icon="star"
                iconType="fontAwesome"
                iconWeight="fa"
            />
        ));
    };

    const iconSite = {
        src: `${IMAGE.ASSETS}/${site_name?.split('.')[0]}-mini.png`,
        alt: `${site_name} logo`,
        onError: i => i.target.src = `${IMAGE.ASSETS}/web.png`,
        style: { width: '12px', margin: '-2px 2px 0 0' }
    }

    return <div style={{ overflow: 'visible', position: 'relative' }} className="calendar-icons">
        <AppTooltip
            title={i18n.t('common:misc.showLocationDetails')}
            containerProps={{
                ref: detailsRef,
                onClick: e => {
                    e.preventDefault()
                    setIsOpen( prevIsOpen => !prevIsOpen)
                },
                className: `occupation-percentage occupation-percentage${getOccupationClass(occupation_dates[date]?.occupation)}`
            }}
        >
            {occupation_dates[date]?.occupation}%
        </AppTooltip>
        { isOpen && <div className="events-panel">
            <OutsideAlerter 
                open={isOpen} 
                setOpen={() => setIsOpen(false)}
                parentRef={detailsRef}
            >
                <div>
                    <div className="calendar-details">
                        <div className="app-card__text-panel">
                            <p className="app-card__text-panel-title" style={{ marginBottom: '4px' }}>
                                Destination availability on the OTA
                            </p>
                            <div className="app-card__text-panel-header">
                                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", gap: '4px' }}>
                                    {location_name} -
                                    <div style={{ display: 'flex', alignItems: 'center' }} >
                                        {renderStars()}
                                    </div>
                                </div>
                            </div>
                            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: '8px', fontSize: '11px', color: '#6B7280', marginTop: '4px' }}>
                                <span style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
                                    { site_name && <div className="tag">
                                        <ImgS {...iconSite} /> {site_name}
                                    </div> }
                                </span>
                                <span style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
                                    <IconSeekers icon="bed" iconType="fontAwesome" iconWeight="fa" style={{ fontSize: '10px', color: '#3B82F6' }} />
                                    <span style={{ fontWeight: '600' }}>{type_accommodation}</span>
                                </span>
                                <span style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
                                    <IconSeekers icon="users" iconType="fontAwesome" iconWeight="fa" style={{ fontSize: '10px', color: '#10B981' }} />
                                    <span style={{ fontWeight: '600' }}>{occupancy}</span>
                                </span>
                                {nights && <span style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
                                    <IconSeekers icon="moon" iconType="fontAwesome" iconWeight="fa" style={{ fontSize: '10px', color: '#8B5CF6' }} />
                                    <span style={{ fontWeight: '600' }}>{nights}</span>
                                </span>}
                            </div>
                            {latestSearchDate?.date && (
                                <div className="last-update-container">
                                    <IconSeekers 
                                        icon="clock" 
                                        iconType="fontAwesome" 
                                        iconWeight="fa"
                                    />
                                    <div className="last-update-content">
                                        <span><span>{i18n.t('common:misc.lastUpdate')}:</span> {latestSearchDate.date}<AppTimezoneLabel tz={latestSearchDate.timezone} /></span>
                                        {occupation_dates[date]?.screenshot && (
                                            <AppTooltip title={i18n.t('common:misc.viewScreenshot')}>
                                                <div className="screenshot-button">
                                                    <IconButtonSeeker
                                                        icon="image"
                                                        iconType="fontAwesome"
                                                        iconWeight="fal"
                                                        onClick={() => window.open(occupation_dates[date].screenshot, '_blank')}
                                                    />
                                                </div>
                                            </AppTooltip>
                                        )}
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </OutsideAlerter>
        </div>}
    </div>
}